import React, { useEffect, useState } from 'react'
import {
    Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, useToast
} from '@chakra-ui/react'
import { useGlobalStore } from '../../store/globalStore'
import ContextCard from '../ContextCard/ContextCard'
import AdminService from '../../API/AdminService'
import { useAdminContextModalStore } from '../../store/modalsStore'
import { useAdminStore } from '../../store/adminStore'

function AdminAddContextModal({isOpen, onClose}) {
    const toast = useToast()
    const contexts = useGlobalStore(state => state.contexts)
    const modalUser = useAdminContextModalStore(state => state.modalUser)
    const setModalUser = useAdminContextModalStore(state => state.setModalUser)
    const contextsPagePaginationData = useAdminStore(state => state.contextsPagePaginationData)
    const setContextsPagePaginationData = useAdminStore(state => state.setContextsPagePaginationData)

    const [selectedContext, setSelectedContext] = useState(null)
    const roleTitles = contexts.reduce((acc, context) => {
        if (acc.includes(context.role.title))
            return acc
        return [...acc, context.role.title]
    }, [])
    const subjectTitles = contexts[0].subjects.map(s => s.title)
    const classYearTitles = contexts[0].class_years.map(cl => cl.title)
    const [roleTitle, setRoleTitle] = useState('')
    const [subjectTitle, setSubjectTitle] = useState('')
    const [classYearTitle, setClassYearTitle] = useState('')
    const [filteredContexts, setFilteredContexts] = useState([])

    useEffect(() => {
        const filterByRole = contexts.filter(c => c.role.title === roleTitle)
        const filterBySubject = filterByRole.filter(c => c.subjects.map(s => s.title).includes(subjectTitle))
        const filterByClassYear = filterBySubject.filter(c => c.class_years.map(cl => cl.title).includes(classYearTitle))
        setFilteredContexts(filterByClassYear)
    }, [roleTitle, subjectTitle, classYearTitle])

    const clearAndClose = () => {
        setSubjectTitle('')
        setRoleTitle('')
        setClassYearTitle('')
        setSelectedContext(null)
        onClose()
    }

    const addContext = () => {
        toast.promise(
            AdminService.addContext(modalUser.id, selectedContext.id),
            {
                success: () => {
                    setModalUser({...modalUser, contexts: [...modalUser.contexts, selectedContext]})
                    setContextsPagePaginationData({...contextsPagePaginationData, results: contextsPagePaginationData.results.map(user => {
                        if (user.id === modalUser.id) {
                            return {...user, contexts: [...user.contexts, selectedContext]}
                        }
                        return user
                    })})
                    clearAndClose()
                    return { title: 'Контекст добавлен' }
                },
                error: (e) => {
                    if (e?.status === 409)
                        return { title: 'У пользователя уже есть данный контекст' }
                    return { title: 'Не удалось добавить контекст' }
                },
                loading: { title: 'Добавление контекста', description: 'Подождите', position: 'top' }
            }
        )
    }

    return (
        <Modal isOpen={isOpen} onClose={clearAndClose} size='xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Добавление контекста</ModalHeader>
                <ModalCloseButton onClick={clearAndClose} />
                <ModalBody>
                    <Select
                        placeholder='Выберите роль'
                        value={roleTitle}
                        onChange={e => setRoleTitle(e.target.value)}
                        marginBottom='calc(var(--default-gap) / 2)'
                    >
                        {roleTitles.map(r => (
                            <option value={r} key={`role-${r}`}>
                                {r}
                            </option>
                        ))}
                    </Select>
                    <Select
                        placeholder='Выберите предмет'
                        value={subjectTitle}
                        onChange={e => setSubjectTitle(e.target.value)}
                        marginBottom='calc(var(--default-gap) / 2)'
                    >
                        {subjectTitles.map(s => (
                            <option value={s} key={`subject-${s}`}>
                                {s}
                            </option>
                        ))}
                    </Select>
                    <Select
                        placeholder='Выберите класс'
                        value={classYearTitle}
                        onChange={e => setClassYearTitle(e.target.value)}
                        marginBottom='calc(var(--default-gap) / 2)'
                    >
                        {classYearTitles.map(t => (
                            <option value={t} key={`class-year-${t}`}>
                                {t}
                            </option>
                        ))}
                    </Select>
                    {filteredContexts.map(c => (
                        <ContextCard
                            context={c}
                            selected={selectedContext && c.id === selectedContext.id}
                            onClick={() => setSelectedContext(c)}
                            key={`admin-add-context-${c.id}`}
                        />
                    ))}
                </ModalBody>
                <ModalFooter>
                    <Button
                        disabled={!selectedContext || !filteredContexts.map(c => c.id).includes(selectedContext.id)}
                        onClick={addContext}
                    >
                        Добавить
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default AdminAddContextModal
